import React, {useEffect, useState} from 'react';
import {Plan} from '../types/Plan';
import {RozpoctovaSkladbaVO, StromApi} from '../api';
import {Button, Col, Row} from 'react-bootstrap';

interface PolozkaDetailProps {
    plan: Plan;
}

export const PolozkaDetail: React.FC<PolozkaDetailProps> = ({plan}) => {
    const [skladba, setSkladba] = useState<RozpoctovaSkladbaVO>();
    const [showDetail, setShowDetail] = useState(false);

    useEffect(() => {
        loadOptions();
    }, [plan]);

    const loadOptions = () => {
        const fetchData = async () => {
            let data: RozpoctovaSkladbaVO;
            try {
                data = (await StromApi.getRozpoctovaSkladba(plan.idPlan)).data;
                setSkladba(data);
            } catch (error) {
                // TODO
            }
        };
        fetchData();
    };

    if (showDetail) {
        const kodFinPolozka = skladba?.kodFinPolozka ? ' (' + skladba?.kodFinPolozka + ')' : '';
        const kodParagraf = skladba?.kodParagraf ? ' (' + skladba?.kodParagraf + ')' : '';
        const kodZaznamovaPolozka = skladba?.kodZaznamovaPolozka ? '(' + skladba?.kodZaznamovaPolozka + ')' : '';
        const kodUcelovyZnak = skladba?.kodUcelovyZnak ? ' (' + skladba?.kodUcelovyZnak + ')' : '';
        const kodNastroj = skladba?.kodNastroj ? ' (' + skladba?.kodNastroj + ')' : '';
        const kodZdroj = skladba?.kodZdroj ? ' (' + skladba?.kodZdroj + ')' : '';
        const kodOdpovedneStredisko = skladba?.kodOdpovedneStredisko ? ' (' + skladba?.kodOdpovedneStredisko + ')' : '';

        return (
            <div style={{paddingTop: 20, paddingBottom: 20}}>
                <div className={'smaller-text'}>
                    <Row>
                        <Col className={'bigger-text'}>Rozpočtová skladba</Col>
                        <Col style={{textAlign: 'right'}}>
                            <Button onClick={() => setShowDetail(false)} variant="link">
                                Skrýt
                            </Button>
                        </Col>
                    </Row>
                    <div className={'grey'}>Finanční položka</div>
                    <div> {skladba?.nazevFinPolozka ? skladba?.nazevFinPolozka + kodFinPolozka : '-'}</div>
                    <div className={'grey'}>Paragraf</div>
                    <div> {skladba?.nazevParagraf ? skladba?.nazevParagraf + kodParagraf : '-'}</div>
                    <div className={'grey'}>Záznamová položka</div>
                    <div>{skladba?.nazevZaznamovaPolozka ? skladba?.nazevZaznamovaPolozka + kodZaznamovaPolozka : '-'}</div>
                    <div className={'grey'}>Účelový znak</div>
                    <div>{skladba?.nazevUcelovyZnak ? skladba?.nazevUcelovyZnak + kodUcelovyZnak : '-'}</div>
                    <div className={'grey'}>Nástroj</div>
                    <div>{skladba?.nazevNastroj ? skladba?.nazevNastroj + kodNastroj : '-'}</div>
                    <div className={'grey'}>Zdroj</div>
                    <div>{skladba?.nazevZdroj ? skladba?.nazevZdroj + kodZdroj : '-'}</div>
                    <div className={'grey'}>Odpovědné středisko</div>
                    <div>{skladba?.nazevOdpovedneStredisko ? skladba?.nazevOdpovedneStredisko + kodOdpovedneStredisko : '-'}</div>
                </div>
            </div>
        );
    }

    return (
        <Button variant="link" onClick={() => setShowDetail(true)}>
            Zobrazit detailní informace...
        </Button>
    );
};
